import _extends from "babel-runtime/helpers/extends";
import React from "react";
import { compose, lifecycle, pure } from "recompose";
import withRouter from "react-router-dom/withRouter";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import ReactGA from "react-ga";

import quizzService from "../../stores/quizz";

import Question from "../../components/Question";

import { Play, CheckPanel } from "./style";

export default compose(withRouter, connect(function (_ref) {
  var quizz = _ref.quizz,
      _ref$app$questions = _ref.app.questions,
      questions = _ref$app$questions === undefined ? [] : _ref$app$questions;
  return { quizz: quizz, questions: questions };
}, function (dispatch) {
  return {
    onReset: function onReset() {
      return dispatch(quizzService.reset());
    },
    onAnswer: function onAnswer(index) {
      return dispatch(quizzService.answer(index));
    },
    onNext: function onNext() {
      return dispatch(quizzService.next());
    }
  };
}, function (_ref2, dispatchProps, ownProps) {
  var questions = _ref2.questions,
      quizz = _ref2.quizz;
  return _extends({
    total: questions.length,
    isCompleted: quizzService.isCompleted(quizz, questions),
    hasWon: quizzService.hasWon(quizz, questions),
    score: quizzService.getScore(quizz, questions),
    currentQuestion: quizzService.getCurrentQuestion(quizz, questions)
  }, ownProps, dispatchProps);
}), pure, lifecycle({
  componentDidMount: function componentDidMount() {
    this.props.reset && this.props.reset();
  }
}))(function Play(_ref3) {
  var currentQuestion = _ref3.currentQuestion,
      total = _ref3.total,
      isCompleted = _ref3.isCompleted,
      hasWon = _ref3.hasWon,
      score = _ref3.score,
      onAnswer = _ref3.onAnswer,
      onNext = _ref3.onNext,
      onReset = _ref3.onReset,
      location = _ref3.location,
      ResultsComponent = _ref3.results;

  if (isCompleted) {
    ReactGA.pageview(location.pathname + "/" + (hasWon ? "won" : "lost"));
  }
  return React.createElement(
    Play,
    null,
    React.createElement(
      Helmet,
      null,
      !!currentQuestion && !isCompleted && React.createElement("body", { className: "question-" + currentQuestion.index }),
      !!isCompleted && React.createElement("body", { className: hasWon ? "quiz-valid" : "quiz-invalid" })
    ),
    !isCompleted && React.createElement(Question, _extends({}, currentQuestion, {
      total: total,
      onNext: onNext,
      onAnswer: onAnswer
    })),
    isCompleted && React.createElement(
      CheckPanel,
      null,
      React.createElement(ResultsComponent, { hasWon: hasWon, score: score, onReset: onReset })
    )
  );
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/pages/Play/index.js
// module id = 144
// module chunks = 0